import { BenefitAddWizardPanel, BenefitBuyupWizardPanel, BenefitCancelWizardPanel, BenefitCheckoutWizardPanel, BenefitTerminateWizardPanel } from './wizard-panels';
import { IListItem, ListItem } from 'src/app/models/listItem';

// Universal Titles
const WizardPanelTitleBenefits: IListItem = {
    value: BenefitAddWizardPanel.benefits,
    text: 'Available Benefits'
}
const WizardPanelTitleCoreBenefits: IListItem = {
    value: BenefitAddWizardPanel.coreBenefits,
    text: 'Core Benefits'
}
const WizardPanelTitleTobacco: IListItem = {
    value: BenefitAddWizardPanel.tobacco,
    text: 'Tobacco Usage'
}
const WizardPanelTitleCoverage: IListItem = {
    value: BenefitAddWizardPanel.coverage,
    text: 'Coverage Selection'
}
const WizardPanelTitleEligibility: IListItem = {
    value: BenefitAddWizardPanel.eligibility,
    text: 'General Eligibility Questions'
}
const WizardPanelTitleAdditionalInfo: IListItem = {
    value: BenefitAddWizardPanel.additionalInfo,
    text: 'Additional Info'
}
const WizardPanelTitlePcp: IListItem = {
    value: BenefitAddWizardPanel.pcp,
    text: 'Primary Care Physician (PCP)'
}
const WizardPanelTitleBeneficiary: IListItem = {
    value: BenefitAddWizardPanel.beneficiary,
    text: 'Beneficiary'
}
const WizardPanelTitleAutoTerm: IListItem = {
    value: BenefitAddWizardPanel.autoTerm,
    text: 'Auto-Termination'
}
const WizardPanelTitleDpDisclaimer: IListItem = {
    value: BenefitAddWizardPanel.dpDisclaimer,
    text: 'Domestic Partner Disclaimer'
}
const WizardPanelTitleDisclaimer: IListItem = {
    value: BenefitAddWizardPanel.disclaimer,
    text: 'Disclaimer'
}
const WizardPanelTitleSummary: IListItem = {
    value: BenefitAddWizardPanel.summary,
    text: 'Summary'
}
const WizardPanelTitleFinalize: IListItem = {
    value: BenefitAddWizardPanel.finalize,
    text: 'Finalize'
}
const WizardPanelTitleRequestTerm: IListItem = {
    value: BenefitAddWizardPanel.requestTerm,
    text: 'Request Termination'
}
const WizardPanelTitleAutoEnroll: IListItem = {
    value: BenefitAddWizardPanel.autoEnroll,
    text: 'Auto Enrollment'
}


// BenefitAddWizardPanel
const WizardPanelTitleAddFutureBenefits: IListItem = {
    value: BenefitAddWizardPanel.futureBenefits,
    text: 'Future Benefits'
}
const WizardPanelTitleAddKitBenefits: IListItem = {
    value: BenefitAddWizardPanel.kitBenefits,
    text: 'Optional Benefit Coverages'
}
const WizardPanelTitleAddFutureBenefitsDisclaimer: IListItem = {
    value: BenefitAddWizardPanel.futureBenefitsDisclaimer,
    text: 'Future Benefits Disclaimer'
}


// BenefitBuyUpWizardPanel
const WizardPanelTitleBuyUpOptionalBenefits: IListItem = {
    value: BenefitBuyupWizardPanel.optionalBenefits,
    text: 'Optional Benefit Coverages'
}


// BenefitCancelWizardPanel
const WizardPanelTitleCancelRequests: IListItem = {
    value: BenefitCancelWizardPanel.requests,
    text: 'Requests to Terminate'
}


// BenefitTerminateWizardPanel
const WizardPanelTitleTerminateBenefits: IListItem = {
    value: BenefitTerminateWizardPanel.benefits,
    text: 'Benefits to Terminate'
}
const WizardPanelTitleTerminateAutoTerm: IListItem = {
    value: BenefitTerminateWizardPanel.autoTerm,
    text: 'Auto-Termination'
}


// BenefitCheckoutWizardPanel
const WizardPanelTitleCheckoutDependentSSN: IListItem = {
    value: BenefitCheckoutWizardPanel.dependentSSN,
    text: 'DependentSSN'
}
const WizardPanelTitleCheckoutDependentVerify: IListItem = {
    value: BenefitCheckoutWizardPanel.dependentVerify,
    text: 'Dependent Verification'
}
const WizardPanelTitleCheckoutWaiveDocuments: IListItem = {
    value: BenefitCheckoutWizardPanel.waiveDocuments,
    text: 'Waive Documents'
}
const WizardPanelTitleCheckoutUSAePay: IListItem = {
    value: BenefitCheckoutWizardPanel.usaePay,
    text: 'USA ePay'
}
const WizardPanelTitleCheckoutDocuments: IListItem = {
    value: BenefitCheckoutWizardPanel.documents,
    text: 'Required Disclosures'
}
const WizardPanelTitleCheckoutSpouseSurcharge: IListItem = {
    value: BenefitCheckoutWizardPanel.spouseSurcharge,
    text: 'Spouse Surcharge'
}
const WizardPanelTitleCheckoutSpouseExclusion: IListItem = {
    value: BenefitCheckoutWizardPanel.spouseExclusion,
    text: 'Spouse Exclusion'
}
const WizardPanelTitleCheckoutSmokerSurcharge: IListItem = {
    value: BenefitCheckoutWizardPanel.smokerSurcharge,
    text: 'Smoker Surcharge'
}
const WizardPanelTitleCheckouAdminEvent: IListItem = {
    value: BenefitCheckoutWizardPanel.adminEvent,
    text: 'AdminEvent'
}
const WizardPanelTitleCheckoutBeneficiaries: IListItem = {
    value: BenefitCheckoutWizardPanel.beneficiaries,
    text: 'Beneficiaries'
}
const WizardPanelTitleCheckoutComplete: IListItem = {
    value: BenefitCheckoutWizardPanel.complete,
    text: 'Enrollment Complete'
}



export const WizardPanelTitleAddList: ListItem[] = [
    WizardPanelTitleBenefits,
    WizardPanelTitleAddFutureBenefits,
    WizardPanelTitleAddKitBenefits,
    WizardPanelTitleCoreBenefits,
    WizardPanelTitleTobacco,
    WizardPanelTitleAutoEnroll,
    WizardPanelTitleCoverage,
    WizardPanelTitleEligibility,
    WizardPanelTitleAdditionalInfo,
    WizardPanelTitlePcp,
    WizardPanelTitleBeneficiary,
    WizardPanelTitleAutoTerm,
    WizardPanelTitleDpDisclaimer,
    WizardPanelTitleDisclaimer,
    WizardPanelTitleSummary,
    WizardPanelTitleFinalize,
    WizardPanelTitleAddFutureBenefitsDisclaimer,
    WizardPanelTitleRequestTerm
];

export const WizardPanelTitleBuyUpList: ListItem[] = [
    WizardPanelTitleBenefits,
    WizardPanelTitleBuyUpOptionalBenefits,
    WizardPanelTitleCoreBenefits,
    WizardPanelTitleTobacco,
    WizardPanelTitleCoverage,
    WizardPanelTitleEligibility,
    WizardPanelTitleAdditionalInfo,
    WizardPanelTitlePcp,
    WizardPanelTitleBeneficiary,
    WizardPanelTitleAutoTerm,
    WizardPanelTitleDpDisclaimer,
    WizardPanelTitleDisclaimer,
    WizardPanelTitleSummary,
    WizardPanelTitleFinalize,
    WizardPanelTitleRequestTerm
];

export const WizardPanelTitleCancelList: ListItem[] = [
    WizardPanelTitleCancelRequests,
    WizardPanelTitleSummary,
    WizardPanelTitleFinalize,
];

export const WizardPanelTitleFSAList: ListItem[] = [
    WizardPanelTitleSummary,
    WizardPanelTitleFinalize,
];

export const WizardPanelTitleTerminateList: ListItem[] = [
    WizardPanelTitleTerminateBenefits,
    WizardPanelTitleTerminateAutoTerm,
    WizardPanelTitleRequestTerm,
    WizardPanelTitleSummary,
    WizardPanelTitleFinalize,
];

export const WizardPanelTitleWaiveList: ListItem[] = [
    WizardPanelTitleTerminateBenefits,
    WizardPanelTitleTerminateAutoTerm,
    WizardPanelTitleRequestTerm,
    WizardPanelTitleSummary,
    WizardPanelTitleFinalize,
];

export const WizardPanelTitleCheckoutList: ListItem[] = [
    WizardPanelTitleCheckoutDependentSSN,
    WizardPanelTitleCheckoutDependentVerify,
    WizardPanelTitleCheckoutWaiveDocuments,
    WizardPanelTitleCheckoutUSAePay,
    WizardPanelTitleCheckoutDocuments,
    WizardPanelTitleCheckoutSpouseSurcharge,
    WizardPanelTitleCheckoutSpouseExclusion,
    WizardPanelTitleCheckoutSmokerSurcharge,
    WizardPanelTitleAutoEnroll,
    WizardPanelTitleCheckouAdminEvent,
    WizardPanelTitleCheckoutBeneficiaries,
    WizardPanelTitleRequestTerm,
    WizardPanelTitleSummary,
    WizardPanelTitleFinalize,
    WizardPanelTitleCheckoutComplete,
];


